import Icon from 'components/icons/Icon';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { usePermitStore } from 'stores/permitStore';
import {
  Maybe,
  ParkingSpace,
  Pmc,
  UnifiedPermit,
} from 'types/generatedSchemaTypes';
import { getParkingSpacesText } from 'utils/permitUtils';
import TicketRow from './TicketRow';
import { useUiStore } from 'stores/uiStore';

type ParkingSpaceRowProps = {
  uid?: string;
  parkingSpaces?: Maybe<Maybe<ParkingSpace>[]>;
  pmc?: Maybe<Pmc>;
  permit: UnifiedPermit;
  orderLineIdWithVersion?: Maybe<string>;
};
const ParkingSpaceRow = ({
  uid,
  parkingSpaces,
  pmc,
  permit,
  orderLineIdWithVersion,
}: ParkingSpaceRowProps) => {
  const { t } = useTranslation();
  const getParkingSpaceContent = () => {
    if (
      permit?.permitType === 'SALES_ORDER' &&
      pmc?.reservationType === 'RESERVED'
    ) {
      return getParkingSpacesText(
        (parkingSpaces ?? []).filter(
          (space): space is ParkingSpace => space !== null
        ),
        permit?.freetextParkingSpaceNo
      );
    }
    return t('longTermParking.any');
  };

  const handleParkingSpacePress = () => {
    if (
      permit?.permitType === 'SALES_ORDER' &&
      pmc?.reservationType === 'RESERVED'
    ) {
      usePermitStore.getState().setSelectedPermit(orderLineIdWithVersion ?? '');
      useUiStore.getState().setSheetModal('parkingSpaces');
    }
  };

  return (
    <TicketRow
      title={t('longTermParking.parkingSpace')}
      content={getParkingSpaceContent()}
      icon={
        parkingSpaces && parkingSpaces?.length > 3 ? (
          <Icon name="Chevron_Right" size="s" />
        ) : null
      }
      testID={`permit-${uid}-parking-space`}
      onPress={handleParkingSpacePress}
    />
  );
};

export default ParkingSpaceRow;
